import PropTypes from 'prop-types';
import React from "react";
import { Link } from "react-router-dom";
import {
  Row,
  Card,
  CardBody,
  CardFooter,
  Col,
  UncontrolledTooltip,
} from "reactstrap";
import { size, map } from "lodash";
import classnames from "classnames"

const CardContact = props => {
  const { user } = props;

  return (
    <React.Fragment>
      <Row>
      <Col lg="12">
      <div className="mt-4 mt-xl-3">
        <p className="text-info mb-0">
          <i className={classnames("fa fa-caret-right","font-size-16 align-middle text-info me-2")} />
          {'Applicant'}
        </p>
        <h4 className="mt-1 mb-0 mt-0">{user.applicant}</h4>
        <p className="text-muted mb-4">
          {`${user.address} ${user.city}, ${user.state} ${user.zipcode}`}
        </p>
      </div>

      </Col>
      </Row>        
    </React.Fragment>
  );
};

CardContact.propTypes = {
  user: PropTypes.object
};

export default CardContact;
